import { render } from "./OurportfolioAssets.vue?vue&type=template&id=085a19ac&scoped=true"
import script from "./OurportfolioAssets.vue?vue&type=script&lang=js"
export * from "./OurportfolioAssets.vue?vue&type=script&lang=js"

import "./OurportfolioAssets.vue?vue&type=style&index=0&id=085a19ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085a19ac"]])

export default __exports__